export function PaymentSummary({
  totalAmount,
  paidAmount,
  onPaidChange,
  prefix,
  chargesLabel = "Total Charges",
}) {
  const total = parseFloat(totalAmount) || 0;
  const paid = parseFloat(paidAmount) || 0;
  const remaining = total - paid;

  const remainColor =
    total === 0
      ? "#6c757d"
      : remaining <= 0
        ? "#198754" // fully paid  — green
        : paid > 0
          ? "#f0a500" // partial     — amber
          : "#dc3545"; // nothing paid — red

  const statusText =
    total === 0
      ? "—"
      : remaining <= 0
        ? "✓ Paid"
        : paid > 0
          ? "Partial"
          : "Unpaid";

  return (
    <>
      {/* paid amount input — same style as other NumInputs */}

      <div className="section">
        <label>Paid Amount</label>
        <NumInput
          id={`${prefix}PaidAmountInput`}
          value={paidAmount}
          onChange={onPaidChange}
          placeholder="0.00"
        />
      </div>

      {/* summary strip — only shown when total is set */}

      {total > 0 && (
        <div
          className="section"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 8,
            padding: "10px 12px",
            borderRadius: 6,
            background: "#f8f9fa",
            border: "1px solid #dee2e6",
            marginBottom: 8,
          }}
        >
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 11, color: "#6c757d", marginBottom: 3 }}>
              {chargesLabel}
            </div>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#212529" }}>
              {getAmountInCurrencyFormat(total)}
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              borderLeft: "1px solid #dee2e6",
              borderRight: "1px solid #dee2e6",
            }}
          >
            <div style={{ fontSize: 11, color: "#6c757d", marginBottom: 3 }}>
              Paid
            </div>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#198754" }}>
              {getAmountInCurrencyFormat(paid)}
            </div>
          </div>

          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 11, color: "#6c757d", marginBottom: 3 }}>
              {remaining <= 0 ? "Status" : "Remaining"}
            </div>
            <div style={{ fontSize: 14, fontWeight: 700, color: remainColor }}>
              {remaining <= 0
                ? statusText
                : getAmountInCurrencyFormat(remaining)}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export function RWSelect({ id, value, onChange }) {
  return (
    <select
      id={id}
      className="rw-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Select</option>
      <option value="R">R</option>
      <option value="W">W</option>
    </select>
  );
}

export function StatusSelect({ id, value, onChange }) {
  return (
    <select
      id={id}
      className="status-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Select</option>
      <option value="D&L">D &amp; L</option>
      <option value="Pending">Pending</option>
    </select>
  );
}

const ROWheading = () => (
  <h5
    style={{
      textDecoration: "underline 3px solid #575656",
      color: "#ffffff",
      padding: 4,
      fontFamily: "Inria Serif",
      marginTop: 10,
      marginBottom: 10,
    }}
  >
    Rate of Work
  </h5>
);
